import { Injectable, EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class LocalizationService {
  languageChanged = new EventEmitter<string>();
  constructor(private translateService: TranslateService) {}

  setUserLang(lang: string) {
    localStorage.setItem('userLang', lang);
    this.languageChanged.emit(lang);
    if (lang) {
      this.translateService.use(lang);
      this.setDirection(lang);
    }
  }

  getUserLang() {
    let lang = localStorage.getItem('userLang') || 'en';
    this.setDirection(lang);
    this.languageChanged.emit(lang);

    return lang;
  }
  private setDirection(lang: string) {
    const dir = lang === 'ar' ? 'rtl' : 'ltr';
  
    if (typeof document !== 'undefined') {
      const appEl = document.getElementById('app');
      if (appEl) {
        appEl.setAttribute('dir', dir);
      }
    }
  }
  
  
}
